import { UseQueryOptions } from '@tanstack/react-query';

import { DirectMail } from 'domains/content/types';
import { CuredApiPaths } from 'models/enums';

import useQuery from '../useQuery';

import QueryKeys from './keys';

export type DirectMailListItem = Pick<DirectMail, 'id' | 'name'>;

/**
 * Returns a react query hook containing the direct mails data.
 * @param reactQueryOptions - Optional react-query options.
 * @param axiosOptions - Options for axios request (e.g., params for query string)
 * @returns A react query hook with direct mails data.
 */
const useDirectMails = (
    reactQueryOptions?: UseQueryOptions<DirectMailListItem[], Error>,
    axiosOptions?: { params?: { status?: string } }
) => {
    // Always filter by status=published,live
    const mergedAxiosOptions = {
        ...axiosOptions,
        params: {
            ...axiosOptions?.params,
            status: 'published,live',
        },
    };

    return useQuery<DirectMailListItem[]>(
        QueryKeys.DIRECT_MAILS,
        CuredApiPaths.DIRECT_MAIL,
        reactQueryOptions,
        mergedAxiosOptions
    );
};

export default useDirectMails;
